<div class="height-100 bg-col-w p-t-15 p-l-10 p-r-10 p-r-4-s p-l-4-s p-t-7-s p-t-12-m overflow-auto custom-scrollbar">
    <form #form="ngForm"
          novalidate="true"
          method="post"
          class="block">
        <div class="flex flex-middle flex-justify-between p-b">
            <p sizeClass="XL:h3, !SM:h4"
               *iCms="'title' of content; skipEmpty: true"></p>
            <button class="bg-col-5 b-radius-max pos-relative ratio-1-1"
                    [style.width.rem]="2.5"
                    role="button"
                    aria-label="Close"
                    (click)="close()">
                <i class="flex flex-middle flex-justify-center top-0 left-0 right-0 bottom-0 pos-absolute icon-close"
                   style="font-size: 0.875em"
                   aria-hidden="true"></i>
            </button>
        </div>
        <p class="p1 p-b-8"
           *iCms="'copy' of content; skipEmpty: true"></p>
        <div class="flex flex-justify-between flex-top">
            @if (!isSuccess) {
            <div>
                <p class="p1 m-b-2">{{'Select photo to upload' | translate }}<span class="col-2"
                          style="margin-left: 1px">*</span></p>
                <div class="flex flex-middle flex-wrap">
                    <file-input class="block m-r"
                                (fileChange)="onFilechange($event)"
                                [maxSize]="'5MB'"
                                [inputId]="'ugcImageInput'"
                                [accept]="'image/jpeg,image/png'"> <label for="ugcImageInput"
                               class="button-1 p-r-5 p-l-5">{{'Choose file' |
                            translate }} </label>
                    </file-input>
                    @if (filename) {
                    <p class="p1">{{filename}}</p>
                    }
                </div>
                <result class="m-t-1"
                        [status]="fileStatus"></result>
                @if (!data?.image) {
                <input-wrap>
                    <input type="hidden"
                           name="image"
                           [(ngModel)]="data.image"
                           required>
                </input-wrap>
                }
            </div>
            }
            @if (isSuccess) {
            <div>
                <h3 class="h3 m-b-7 m-b-8-s">{{'Thank you for sharing!' | translate }}</h3>
                <p class="p2"
                   *ifSize="'!S'"
                   style="max-width: 311px;">{{'Thanks for submitting your customer homes images for approval. They
                    should be available to view online soon.' |
                    translate }}</p>
            </div>
            }
        </div>
        @if (isSuccess) {
        <p class="p2"
           *ifSize="'S'"
           style="max-width: 311px;">{{'Thanks for submitting your customer homes images for approval. They should
            be available to view online soon.' |
            translate }}</p>
        }
        @if (!isSuccess) {
        <input-wrap class="w-12 m-t-7 m-t-5-s">
            <input class="input"
                   type="text"
                   name="name"
                   [muiInput]="('Name to display'| translate)"
                   [(ngModel)]="data.user_tag"
                   required>
        </input-wrap>
        <input-wrap class="w-12 m-t-6">
            <input class="input"
                   type="text"
                   name="item"
                   [muiInput]="('Item/s in photo?'| translate)"
                   [(ngModel)]="data.item_in_photo">
        </input-wrap>
        <input-wrap class="m-t-7 block"
                    style="padding-left: 2px;">
            <checkbox name="consent"
                      [top]="true"
                      [required]="true"
                      [(ngModel)]="consent">
                <span class="p2 block">
                    {{'I am happy for my photo to be featured on the Barker and Stonehouse website and marketing
                    materials.' | translate}}<span class="col-2">*</span>
                </span>
            </checkbox>
        </input-wrap>
        <action [status]="status"
                class="button m-t-10 p-r-5 p-l-5"
                (click)="submit()"><span style="letter-spacing: 0px !important;">{{'Upload your photo' |
                translate}}</span></action>
        <result class="m-t-1 block"
                [status]="status"></result>
        <span class="p2 block m-t-7">
            <span class="col-2">*</span>denotes required field
        </span>
        }
    </form>

</div>